import { Divider, Group, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import {
  TraceabilityResponses,
  typeTextContent,
} from "@tfg/types/endpoints/traceability"

import { IconRawMaterial } from "~/components/icons/activities/IconRawMaterial"
import { useGetTranslation } from "~/utils/translations.ts"

interface MaterialCompositionProps {
  item: TraceabilityResponses.ComponentTraceabilityRequestItem
}

export const CompositionItem = ({
  type,
  proportion,
}: {
  type: typeTextContent
  proportion: number
}) => {
  const label = useGetTranslation(type)
  return (
    <Group wrap="nowrap" justify="space-between">
      <Text>{label}</Text>
      <Text>{proportion}%</Text>
    </Group>
  )
}

export const MaterialComposition = ({ item }: MaterialCompositionProps) => {
  const { t } = useTranslation(["traceability"])

  return (
    <Stack maw="100%" gap="xs">
      <Group gap={4}>
        <IconRawMaterial size={16} />
        <Text fw="bold">{t("item.material_other")}</Text>
        <Divider w="100%" />
      </Group>
      {item.children.map((child, index) => (
        <CompositionItem
          key={`${child.itemInformation.type}-${index}`}
          type={child.itemInformation.type}
          proportion={child.itemInformation.proportion}
        />
      ))}
    </Stack>
  )
}
